export default __webpack_public_path__ + "static/location-coming-soon-d48779fa19b91d41cb83f205ffd0b5bf.jpg";